if (!customElements.get('zn-bench-preview')) {
  customElements.define('zn-bench-preview', class extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const viewer = this.querySelector('model-viewer');
      const status = this.querySelector('[data-status]');
      const labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      const fields = Object.fromEntries(['headrest','backrest','seat'].map(key => [key,{
        input:this.querySelector(`[data-joint="${key}"]`),output:this.querySelector(`[data-output="${key}"]`)
      }]));
      const toggle = this.querySelector('[data-mount]');
      let config, state, savedHead, available;
      const locked = value => config.backrest.settings[value.backrest].angle_deg < 0;
      const idFor = value => `Pose_B${value.backrest}_H${value.headrest}_S${value.seat}_M${Number(value.mount==='back')}`;
      const apply = () => {
        for (const key of Object.keys(fields)) {
          const spec=config[key], index=state[key], field=fields[key];
          field.input.value=index;
          const angle=spec.settings[index].angle_deg;
          let value=`${labels.position} ${index+1} / ${spec.count}`;
          if (key==='backrest') value=`${angle<0?labels.decline:angle===0?labels.flat:labels.incline} ${Number(angle.toFixed(1))}°`;
          if (key==='headrest' && locked(state)) value=labels.locked_short;
          field.output.textContent=value;
          field.input.setAttribute('aria-valuetext',value);
        }
        fields.headrest.input.disabled=locked(state);
        toggle.checked=state.mount==='back';
        const backAngle=config.backrest.settings[state.backrest].angle_deg;
        const targetY=.24+.40*Math.max(0,Math.sin(backAngle*Math.PI/180));
        viewer.setAttribute('camera-target',`0m ${targetY.toFixed(3)}m 0m`);
        viewer.animationName=idFor(state);
        viewer.currentTime=0;
        viewer.play({repetitions:1});
        status.textContent=locked(state)?labels.locked:labels.ready;
      };
      const change=(key,value) => {
        const next={...state,[key]:value};
        if (key==='headrest' && locked(state)) return;
        if (!locked(state) && locked(next)) { savedHead=state.headrest; next.headrest=0; }
        else if (locked(state) && !locked(next)) next.headrest=savedHead;
        if (!available.has(idFor(next))) { apply(); return; }
        state=next; apply();
      };
      try {
        const response=await fetch(this.dataset.configUrl);
        if (!response.ok) throw new Error('Config unavailable');
        config=await response.json();
        state={headrest:config.headrest.default_index,backrest:config.backrest.default_index,seat:config.seat.default_index,mount:'leg'};
        savedHead=state.headrest;
        for (const [key,field] of Object.entries(fields)) {
          field.input.max=config[key].count-1;
          field.input.value=state[key];
          field.input.addEventListener('input',()=>change(key,Number(field.input.value)));
        }
        toggle.addEventListener('change',()=>change('mount',toggle.checked?'back':'leg'));
        if (!customElements.get('model-viewer')) {
          await new Promise((resolve,reject)=>Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:error=>error?reject(error):resolve()}]));
          await customElements.whenDefined('model-viewer');
        }
        const ready=()=>{
          available=new Set(viewer.availableAnimations);
          if (!available.has(idFor(state))) { status.textContent=labels.error; return; }
          this.querySelector('fieldset').disabled=false;
          apply();
        };
        viewer.addEventListener('load',ready);
        viewer.addEventListener('error',()=>{status.textContent=labels.error; this.querySelector('fieldset').disabled=true;});
        if (viewer.loaded) ready();
      } catch (error) {
        status.textContent=labels.error;
      }
    }
  });
}
